// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "../../../theme/SwiperOverrides.css";

import * as styles from "./SectionCentrePromotedDogs.module.scss";

import React, { useEffect, useState } from "react";
import { Button } from "../../../components/common";

import { useLazyQuery } from "@apollo/client";
import qs from "qs";
import { dogSearchClient } from "../../../apollo/client";
import { SEARCH_DOG_QUERY } from "../../../apollo/queries";
import DogCardCarousel from "../../../components/DogCardCarousel/DogCardCarousel";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionSpotlightDogsProps {
	currentDogId: string;
	centre: string;
	centreCode: string;
}

export const SectionCentrePromotedDogs: React.FC<SectionSpotlightDogsProps> = ({
	centre,
	currentDogId,
	centreCode,
}) => {
	const [items, setItems] = useState<DogsTrust.DogData[]>([]);

	const [getDogs, { data }] = useLazyQuery(SEARCH_DOG_QUERY, {
		client: dogSearchClient,
		fetchPolicy: "cache-first",
		variables: {
			page: 0,
			sort: "OLD",
			centres: [centreCode],
		},
	});

	// biome-ignore lint/correctness/useExhaustiveDependencies: We want the centreCode to be the only thing that triggers a re-render
	useEffect(() => {
		getDogs();
	}, [getDogs, centreCode]);

	useEffect(() => {
		const mappedItems = ((data?.results?.results || []) as DogsTrust.DogData[])
			.filter((dog) => dog.id !== currentDogId)
			.sort(
				(a, b) => a.media?.images?.[0]?.weight - b.media?.images?.[0]?.weight,
			);
		setItems(mappedItems);
	}, [data, currentDogId]);

	return (
		<WrappedSection
			sectionName="SectionCentrePromotedDogs"
			sectionColour={Colours.SUNSHINE_YELLOW}
		>
			<div className={styles.spotlightdogsinner}>
				<div className={styles.titlewrapper}>
					<h2 className={styles.title}>{`More dogs from ${centre}`}</h2>
				</div>

				<DogCardCarousel dogs={items} />
				<Button
					className={styles.showalldogs}
					{...{
						variant: "tertiary",
						ariaLabel: "link to our dogs",
						fullWidth: true,
						tabIndex: -1, // Link handles tab behaviour
						url: `/rehoming/dogs?${qs.stringify({
							centres: [centreCode],
						})}`,
						children: "Show all dogs",
					}}
				/>
			</div>
		</WrappedSection>
	);
};

export default SectionCentrePromotedDogs;
